import React from "react";
import { useParams, Link } from "react-router-dom";
import UniqueBanner from "../components/UniqueBanner";
import eventData from "../data/eventData";
import "./EventDetails.css";
import BannerImg from "../assets/Institute/DSC_0575.JPG";
import { FaFacebookF, FaTwitter, FaLinkedinIn } from "react-icons/fa";

const EventDetails = () => {
  const { slug } = useParams();
  const event = eventData.find((e) => e.slug === slug);

  if (!event) {
    return (
      <div className="ed-not-found">
        <h2>Event Not Found</h2>
        <Link to="/events" className="ed-back-link">
          Back to Events
        </Link>
      </div>
    );
  }

  return (
    <>
      <UniqueBanner
        image={BannerImg}
        title={event.title}
        subtitle={`${event.date} | ${event.location}`}
      />

      <div className="ed-container">
        {/* ------------------ MAIN TWO-COLUMN SECTION ------------------ */}
        <div className="ed-main-row">
         <div className="ed-left">
  {event.mainContent.length > 0 && (
    <h3 className="ed-main-heading">{event.mainContent[0]}</h3>
  )}

  {event.mainContent.slice(1).map((para, idx) => (
    <p key={idx} className="ed-paragraph">{para}</p>
  ))}

  <button className="ed-registration-closed">Registration Closed</button>
</div>

          <div className="ed-right">
            <img
              src={event.image}
              alt={`${event.title} event`}
              title={`${event.title} event`}
              className="ed-image"
            />
          </div>
        </div>

        {/* ------------------ TIME & LOCATION ------------------ */}
        <div className="ed-section">
          <h3 className="ed-section-title">Time & Location</h3>
          <p className="ed-paragraph">{event.timeLocation.time}</p>
          <p className="ed-paragraph">{event.timeLocation.venue}</p>
        </div>

        {/* ------------------ ABOUT EVENT ------------------ */}
        <div className="ed-section">
          <h3 className="ed-section-title">About the Event</h3>
          {event.aboutEvent.map((para, idx) => (
            <p key={idx} className="ed-paragraph">{para}</p>
          ))}
        </div>

        {/* ------------------ MAP ------------------ */}
        <div className="ed-map">
          <iframe
            title="Event Location"
            src={event.mapEmbed}
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>

        {/* ------------------ SOCIAL SHARE ------------------ */}

<div className="ed-share">
  <h4 className="ed-share-title">Share this event:</h4>
  <div className="ed-social-icons">
    <a
      href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`}
      target="_blank"
      rel="noreferrer"
      className="ed-social-link"
    >
      <FaFacebookF />
    </a>
    <a
      href={`https://twitter.com/intent/tweet?url=${window.location.href}`}
      target="_blank"
      rel="noreferrer"
      className="ed-social-link"
    >
      <FaTwitter />
    </a>
    <a
      href={`https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}`}
      target="_blank"
      rel="noreferrer"
      className="ed-social-link"
    >
      <FaLinkedinIn />
    </a>
  </div>
</div>

      </div>
    </>
  );
};

export default EventDetails;
